"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvinceComplianceCategory = void 0;
var ProvinceComplianceCategory;
(function (ProvinceComplianceCategory) {
    ProvinceComplianceCategory["CANNABIS_OIL"] = "Cannabis Oil";
    ProvinceComplianceCategory["CANNABIS_PLANT_SEEDS"] = "Cannabis Plant Seeds";
    ProvinceComplianceCategory["DRIED_CANNABIS"] = "Dried Cannabis";
    ProvinceComplianceCategory["EDIBLES_SOLIDS"] = "Edibles solids";
    ProvinceComplianceCategory["EDIBLES_NON_SOLIDS"] = "Edibles non-solids";
    ProvinceComplianceCategory["EXTRACTS_INHALED"] = "Extracts inhaled";
    ProvinceComplianceCategory["TOPICALS"] = "Topicals";
})(ProvinceComplianceCategory || (exports.ProvinceComplianceCategory = ProvinceComplianceCategory = {}));
//# sourceMappingURL=provinceProducts.js.map